import React from 'react';
import { Link } from 'react-router-dom';

const Footer5 = () => {
  return (
    <footer className="footer5-cards bg-light py-5 mt-auto border-top">
      <div className="container">
        <div className="row align-items-center gy-1">
          
          {/* Brand & Copyright */}
          <div className="col-lg-3 col-md-12 text-center text-lg-start">
            <h6 className="fw-bold mb-1">TrustBanc Asset Management</h6>
            <p className="text-muted text-white-50 small mb-0">
              Copyright © {new Date().getFullYear()} All Rights Reserved.
            </p>
          </div>

          {/* Regulatory Disclaimer */}
          <div className="col-lg-6 col-md-12 px-lg-5 border-start-lg border-2">
            <p className="small mb-0 lh-sm text-white">
              TrustBanc Asset Management Limited is registered and regulated by the 
              <strong> Securities and Exchange Commission, Nigeria</strong> as a Fund/Portfolio Manager.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-lg-3 col-md-12">
            <div className="d-flex justify-content-center justify-content-lg-end gap-3 small">
              <Link to="/contact" className="text-decoration-none text-white">Contact</Link>
              <span className="text-muted">|</span>
              <Link to="/privacy-policy" className="text-decoration-none text-white">Privacy</Link>
              <span className="text-muted">|</span>
              <Link to="/terms-and-conditions" className="text-decoration-none text-white">Terms</Link>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer5;